import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class JsfUtilsService {

    public getDefaultValidationMessages(): {[key: string]: string} {
        return {
            default: 'ee.form.validation.default',
            required: 'ee.form.validation.required',
            format: 'ee.form.validation.format',
            min: 'ee.form.validation.min',
            max: 'ee.form.validation.max',
            domain: 'ee.form.validation.domain',
        }
    }
}
